/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Spell_Numbers_Start_LabelInputs */



/**
* | output |
* | --- |
* | "Spell Numbers At Start Of Line" |
*
* @param {Style_Guide_Manager_Spell_Numbers_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_spell_numbers_start_label = /** @type {((inputs?: Style_Guide_Manager_Spell_Numbers_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Spell_Numbers_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Epeler les nombres en debut de ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schreibe die Zahlen am Zeilenanfang.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scrivi i numeri all'inizio della riga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Напишите цифры в начале строки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deletrear números al comienzo de la línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在行首拼写数字")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行頭に数字を入力する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पंक्ति के प्रारंभ में संख्याओं की वर्तनी लिखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escreva os números por extenso no início da linha.")
	return /** @type {LocalizedString} */ ("Spell Numbers At Start Of Line")
});